module.exports = __webpack_public_path__ + "img/qualification-img2.6d8f9a43.png";